import { ChangeDetectorRef, Component, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateFormat, FilterMatchMode } from '@capturum/ui/api';
import { DatePipe } from '@angular/common';
import { CalendarFilterConfigItem, DynamicFilterComponent } from '@capturum/ui/dynamic-filters';
import { format } from 'date-fns';
import { FilterConfigItem } from '@capturum/ui/dynamic-filters/interfaces/dynamic-filter.interface';

type CalendarValue = string[] | string;

@Component({
  selector: 'app-calendar-filter',
  templateUrl: './calendar-filter.component.html',
  styleUrls: ['./calendar-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CalendarFilterComponent implements DynamicFilterComponent<CalendarValue> {
  public updateValue: EventEmitter<CalendarValue> = new EventEmitter<CalendarValue>();
  public filterConfig: CalendarFilterConfigItem;
  public formControl = new FormControl();
  public changeByUser: EventEmitter<FilterConfigItem> = new EventEmitter<FilterConfigItem>();

  constructor(private cdr: ChangeDetectorRef, private datePipe: DatePipe) {}

  public setValue(value: CalendarValue): void {
    if (Array.isArray(value)) {
      this.formControl.setValue(value);
    } else {
      this.formControl.setValue(value ? new Date(value as string) : null);
    }

    this.cdr.detectChanges();
  }

  public reset(): void {
    this.formControl.setValue(null);
    this.updateValue.emit(this.formControl.value);
  }

  public handleDateFilterChange(filterMatchMode: FilterMatchMode | string): void {
    if (filterMatchMode === FilterMatchMode.BETWEEN || filterMatchMode === FilterMatchMode.DATEBETWEEN) {
      const dateValues: string[] = this.formControl.value.map((date) => {
        return this.datePipe.transform(date, DateFormat.generalReverse);
      });

      if (dateValues.length === 2 && dateValues.every(Boolean)) {
        this.updateValue.emit(dateValues);
      }
    } else {
      const formattedDate = format(this.formControl.value, `yyyy-MM-dd'T'HH:mm`);

      this.updateValue.emit(formattedDate);
    }
  }

  public updateView(): void {
    this.cdr.detectChanges();
  }
}
